module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hero', {
    staticClass: "is-info",
    attrs: {
      "title": _vm.match === 404 ? 'Not found' : (_vm.match === null ? 'Loading' : _vm.match.Name)
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    staticClass: "button",
    staticStyle: {
      "margin-bottom": "1.5rem"
    },
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), _c('span', [_vm._v("Go back")])]), _vm._v(" "), (_vm.games.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('p', [_vm._v("Latest played games at the top!")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.games), function(game) {
    return _c('game', {
      key: game.ID,
      attrs: {
        "game": game,
        "users": _vm.users,
        "beatmaps": _vm.beatmaps
      }
    })
  })], 2) : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a9b1073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Match.vue
// module id = 143
// module chunks = 1